<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  mounted () {
    this.$store.commit('initHisHeader')
  }
}
</script>

<style lang="scss">
#app {
  height: 100%;
}
</style>
